/*
 * Application Labels Box
 */

/*
 * Only for Page Titles
 */
export const TITLES = {
  FUEL: "Fuel",
  RETURN_APPROVAL: "Return Approval",
  RETURN_REQUEST: "Return Request",
  TRIP_PAYMENT: "Trip Payment",
  TRANSACTION_BUTTON_EXPENSE_RECEIPT: "Trip Receipt",

  BILL_STATUS: "Close Trip",
  PLACEMENT: "Placement",
  TRIPS: "Trips",
  CONTRACTS: "Contracts",
  TEMP_RANGE: "Temperature Range",
  CUSTOMER: "Customers/Supplier/Brokers",
  TRUCKTYPES: "Truck Category",
  USERS: "Users",
  USER: "User",
  EXPENSETYPES: "Expense Types",
  ROUTE_EXPENSE: "Route Expense",
  LOADING: "Loading",
  VEHICLE: "Vehicle",
  LOADING_POINTS: "Loading Points",
  UNLOADING_POINTS: "Unloading Points",
  ROUTE: "Route",
  ASSET: "Asset",
  DRIVERS: "Drivers",
  REPAIRS: "Repairs",
  MAINTENANCE: "Maintenance",
  PARKING_LOT: "Parking Lot",
  REPAIR: "Repair",
  ROI_CALCULATOR: "ROI Calculator",
  LOADING_BAY_MASTER: "Loading Bay",

  ASSETS_REGISTER: "Assets Register",
  EXPENSE_ANALYSIS: "Expense Analysis",
  PROFIT_LOSS_ANALYSIS: "Profit Loss Analysis ",
  NON_MOVEMENT_VEHICLE_LIST: "Non Movement Vehicle List",
  LOADING_BAY: "Loading Bay",
  DELIVERY_COMMENTS_REPORT: "Delivery Comments Report",
  PARKING_LOT_REPORT: "Parking Lot Report",
  INDENT_FLOW_REPORT: "Indent Flow Report",
  TRIPS_REGISTER_REPORT: "Trips Register ",
  FUEL_REGISTER_REPORT: "Fuel Regiser ",
  EXPENSES_REGISTER_REPORT: "Expenses Register",
  REPAIR_REPORT: "Repair Report",
  VEHICLE_LOCATION_REPORT: "Vehicles Location",
  AVAILABLE_DRIVER_LIST: "Available Driver List",
  VEHICLE_LEDGER_REPORT: "Vehicle Ledger",
  DRIVER_LEDGER_REPORT: "Driver Ledger",
  CUSTOMER_SUPPLIER_BROKER_LEDGER: "Customer/Supplier/Broker Ledger",
  LOADING_BAY_REPORT: "Loading Bay Report",
  RETURNS_REPORT: "Returns Report",
  DELIVERY_EFFICIENCY: "Delivery Efficiency",
  DELAYED_DELIVERIES: "Delayed Deliveries",
  ON_TIME_DELIVERY_REPORT: "On Time Delivery Report",
  FILL_RATE_REPORT: "Fill Rate Report",
  DWELL_TIME_REPORT: "Dwell Time Report",
  TURN_AROUND_TIME: "Turn Around Time ",
  IDLE_RUN_REPORT: "Idle  Report",
  TRIP_OVERLOAD_REPORT: "Trip Overload Report",
  DRIVER_KM_DRIVEN: "Driver KM Driven",
  CUSTOMER_TRIP_DETAILS: "Customer Trip Details",
  MILEAGE_REPORT: "Mileage Report",
  HIGH_MILEAGE_VEHICLES: "High Mileage Vehicles",
  ODOMETER_MISMATCH: "Odometer Mismatch",
  FREQUENT_REPAIR_VEHICLES_LIST: "Frequent Repair Vehicles List",
  TYRE_EFFICIENCY_REPORT: "Tyre Efficiency Report",
  TRANSPORTATION_COST: "Transportation Cost",
  TRIP_NOTIFICATION_REPORT: "Trip Notifications",
  ALL_LOGS_REPORT: "All Logs Report",
  USER_LOG_REPORT: "User Log Report",
  VEHICAL_LIST: "Vehicles List",
  DRIVER_REGISTER_REPORT: "Driver Register",
  DRIVERS_LIST_REPORT: "Drivers List",
  VEHICLE_REGISTER_REPORT: "Vehicles Register",
  TRIP_STATUS_REPORT: "Trip Status Register",
  TRIP_LIST: "Trip List",
  TRIP_LEDGER_REPORT: "Trip Ledger",
  MASTERS_BUTTON_VEHICLES: "Vehicles",
  MASTERS_BUTTON_UNLOADING: "Unloading",

  DOCUMENT_RENEWAL_REPORT: "Document Renewal",
  FUEL_REPORT: "Fuel Report",
  FASTAG_REPORT: "Fastag Report",
};

/*
 * Description for the page (Title)
 */
export const SUB_TITLES = {
  FUEL: "Fuel",
  PLACEMENT: "Placement",
  RETURN_APPROVAL: "Return Approval",
  RETURN_REQUEST: "Return Request",
  TRIP_PAYMENT: "Trip Payment",
  TRANSACTION_BUTTON_EXPENSE_RECEIPT: "Trip Receipt",

  DELIVERY_COMMENTS_REPORT: "Delivery Comments Report",
  BILL_STATUS: "Close Trip",
  TRIPS: "Trips",
  TEMP_RANGE: "Temperature Range",
  CUSTOMER: "Customers/Supplier/Brokers",
  TRUCKTYPES: "Here you can Add/Edit Vehicle Truck Categories",
  USERS: "Manage Users",
  CONTRACTS: "Contracts",
  EXPENSETYPES: "Expense Types",
  ROUTE_EXPENSE: "Route Expense",
  LOADING: "Loading",
  VEHICLE: "Vehicle",
  LOADING_POINTS: "Loading Points",
  PARKING_LOT: "Parking Lot",
  UNLOADING_POINTS: "Unloading Points",
  ROUTE: "Route",
  ASSET: "Asset",
  DRIVERS: "Drivers",
  REPAIRS: "Repairs",
  MAINTENANCE: "Maintenance",
  LOADING_BAY_MASTER: "Loading Bay",
  ROI_CALCULATOR: "ROI CALCULATOR",
  ASSETS_REGISTER: "Assets Register",
  EXPENSE_ANALYSIS: "Expense Analysis",
  PROFIT_LOSS_ANALYSIS: "Profit Loss Analysis ",
  NON_MOVEMENT_VEHICLE_LIST: "Non Movement Vehicle List Report",
  LOADING_BAY: "Loading Bay",
  PARKING_LOT_REPORT: "Parking Lot Report",
  INDENT_FLOW_REPORT: "Indent Flow Report",
  TRIPS_REGISTER_REPORT: "Trips Register Report",
  FUEL_REGISTER_REPORT: "Fuel Regiser Report",
  EXPENSES_REGISTER_REPORT: "Expenses Register Report",
  REPAIR_REPORT: "Repair Report",
  VEHICLE_LOCATION_REPORT: "Vehicles Location Report",
  AVAILABLE_DRIVER_LIST: "Available Driver List Report",
  DOCUMENT_RENEWAL_REPORT: "Document Renewal Report",
  DRIVER_LEDGER_REPORT: "Driver Ledger Report",
  CUSTOMER_SUPPLIER_BROKER_LEDGER: "Customer/Supplier/Broker Ledger Report",
  LOADING_BAY_REPORT: "Loading Bay Report",
  RETURNS_REPORT: "Returns Report",
  DELIVERY_EFFICIENCY: "Delivery Efficiency Report",
  DELAYED_DELIVERIES: "Delayed Deliveries Report",
  ON_TIME_DELIVERY_REPORT: "On Time Delivery Report",
  FILL_RATE_REPORT: "Fill Rate Report",
  DWELL_TIME_REPORT: "Dwell Time Report",
  TURN_AROUND_TIME: "Turn Around Time Report ",
  IDLE_RUN_REPORT: "Idle  Report",
  TRIP_OVERLOAD_REPORT: "Trip Overload Report",
  DRIVER_KM_DRIVEN: "Driver KM Driven Report",
  CUSTOMER_TRIP_DETAILS: "Customer Trip Details ",
  MILEAGE_REPORT: "Mileage Report",
  HIGH_MILEAGE_VEHICLES: "High Mileage Vehicles Report",
  ODOMETER_MISMATCH: "Odometer Mismatch Report",
  FREQUENT_REPAIR_VEHICLES_LIST: "Frequent Repair Vehicles List Report",
  TYRE_EFFICIENCY_REPORT: "Tyre Efficiency Report",
  TRANSPORTATION_COST: "Transportation Cost Report",
  TRIP_NOTIFICATION_REPORT: "Trip Notifications Report",
  ALL_LOGS_REPORT: "All Logs Report",
  USER_LOG_REPORT: "User Log Report",
  VEHICAL_LIST: "Vehicles List",
  DRIVER_REGISTER_REPORT: "Driver Register",
  DRIVERS_LIST_REPORT: "Drivers List Report",
  VEHICLE_REGISTER_REPORT: "Vehicles Register",
  TRIP_STATUS_REPORT: "Trip Status Register",
  TRIP_LIST: "Trip List",
  TRIP_LEDGER_REPORT: "Trip Ledger",
  MASTERS_BUTTON_VEHICLES: "Vehicles",
  MASTERS_BUTTON_UNLOADING: "Unloading",

  VEHICLE_LEDGER_REPORT: "Vehicle Ledger Report",
  FUEL_REPORT: "Fuel Report",
  FASTAG_REPORT: "Fastag Report",
};

/*
 * Form Labels, Grid Column names, etc..
 */
export const LABELS = {
  VEHICLES_LIST: "Vehicles",
  CLUSTERING: "Clustering",
  PHOTO_UPLOAD: "Photo Upload",
  LOAD_DATA: "LOAD DATA",
  RADAR: "Radar",
  RTO: "Rto",
  POLICE: "Police",
  CLAIM: "Claim",
  OUTSTANDING: "Outstanding",
  LOADING_EXPENSE: "Loading Expense",
  TOTAL_EXPENSE: "Total Expense",
  UNLOADING_EXPENSE: "Unloading Expense",
  WEIGHTMENT_EXPENSE: "Weightment Expense",
  DRIVER_BATA: "Driver Bata",
  TRANSIT_STATUS: "Transit Status",
  LOAD_STATUS: "Load Status",
  VEHICLE_DELAYS: "Vehicle Delays",
  LOCATE_VEHICLE: "Locate Vehicle",
  TRACK_VEHICLES: "Track  Vehicle",
  SELECT_TRIP: "Select Trip",
  LOAD_DATA_ON_MAP: "Load Data On Map",
  SHOW_DELIVERY: "Show Delivery",
  DELIVERY_COMMENTS: "Delivery Comments",
  MAP_TYPES: "Map Types",
  VEHICLE_WISE: "Vehicle Wise",
  SELECT_DRIVER: "Select Driver",
  FUTURE_VIEW: "Future View",
  VEHICLE_INFORMATION: "Vehicle Information",
  SHOW_VEHICLES: "Show Vehicles",
  MARKERS: "Markers",
  EXPECTED_TIME: "Expected Time",
  MAP_PAGE: "Map Page",
  TRIP_DELIVERIES: "Trip Deliveries",
  TOTAL_COUNT: "Total Count",
  TYPE_NUMBER: "Type Number",
  MY_MAP: "My Map",
  LAST_CHANGED: "Last Changed",
  KM_DRIVEN: "KM Driven",
  MONTH: "Month",
  DEALER_NAME: "Dealer Name",
  TOTAL_DURATION: "Total Duration",
  TOTAL_TRIPS: "Total Trips",
  FILL_RATE_REPORT: "Fill Rate Report",
  DRIVER_MOBILE_NO: "Driver Mobile Number",
  DIFFERENCE: "Diffrence",
  PARKING_LOT: "Parking Lot",
  REPAIR_ICON: "Repair",
  PAYMENT_ICON: "Payment",
  RECEIPT_ICON: "Receipt",

  HIDE_UNHIDE: "Hide Unhide",
  FREEZE_COLS: "Freeze Columns",
  TOTAL: "Total",
  DAYS: "Days",

  EXPECTED_DELIVERY_TIME: "Expected Delivery Time",
  ACTUAL_DELIVERY_TIME: "Actual Delivery Time",
  ON_TIME_DELIVERY_REPORT: "On Time Delivery Report",
  INDENT_FLOW_REPORT: "Indent Flow Report",
  CUSTOMER_TRIP_DETAILS: "Customer Trip Details",
  CUSTOMER_SUPPLIER_BROKER_LEDGER: "Customer/Supplier/Broker Ledger",
  TYRE_EFFICIENCY_REPORT: "Tyre Efficiency Report",
  FREQUENT_REPAIR_VEHICLES_LIST: "Frequent Repair Vehicles List",
  HIGH_MILEAGE_VEHICLES: "High Mileage Vehicles",
  TOTAL_FUEL: "Total Fuel",
  FROM_LOCATION: "From Location",
  TO_LOCATION: "To Location",
  BILLED_STATUS: "Billed Status",
  REPAIR_REPORT: "Repair Report",
  WORK_DESCRIPTION: "Work Description",
  WORKED_ON: "Worked On",
  TRIP_OVERLOAD_REPORT: "Trip Overload Report",
  AVAILABLE_DRIVER_LIST: "Available Driver List",
  ACTUAL_TIME: "Actual Time",
  EXPECTED_KM: "Expected KM",
  ACTUAL_KM: "Actual KM",
  MARKER_LABELS: "Labels",
  MAP_AREAS: "Areas",
  CREATED_ON: "Created On",
  MODIFIED_ON: "Modified On",
  FROM_AREA: "From Area",
  TO_AREA: "To Area",
  REGISTER: "Register",
  LOGS: "Logs",
  ANALYSIS: "Analysis",
  PARKING_STATUS: "Parking Status",
  CURRENT_STATUS: "Current Status",
  BALANCE: "Balance",
  ROUTE_DISTANCE: "Route Distance (In KM)",
  ROUTE_DURATION: "Route Duration (In Hours)",
  FROM_PLACE: "From Place",
  TO_PLACE: "To Place",
  MANIFEST: "Manifest",
  MIN_KM_PER_MONTH: "Min KM Per Month ",
  PER_MONTH_FIXED_AMOUNT: "Per Month Fixed Amount",
  PER_DAY_FIXED_AMOUNT: "Per Day Fixed Amount",
  ROUTE_EXPENSE: "Route Expense",
  PLACEMENT_DATE: "Placement Date",
  CONTRACTS: "Contracts",
  UNDER_MAINTENANCE: "UNDER MAINTENANCE",
  CONTRACT: "Contract",
  VEHICLE_STATUS: "Vehicle Status",
  ACCIDENT: "ACCIDENT",
  FIT: "FIT",
  MANIFEST_1: "Manifest 1",
  MANIFEST_2: "Manifest 2",
  MANIFEST_3: "Manifest 3",
  MANIFEST_4: "Manifest 4",
  MANIFEST_5: "Manifest 5",

  TRIP_NO: "Trip No",
  TRIP_TIME: "Trip Time",
  NON_TRIP_TIME: "Non Trip Time",
  DRIVER_KM_DRIVEN: "Driver KM Driven",
  DWELL_TIME_REPORT: "Dwell Time Report",
  DELIVERY_EFFICIENCY: "Delivery Efficiency",
  DELAYED_DELIVERIES: "Delayed Deliveries",
  MANIFEST_WEIGHT_1: "Manifest Weight 1",
  MANIFEST_WEIGHT_2: "Manifest Weight 2",
  MANIFEST_WEIGHT_3: "Manifest Weight 3",
  MANIFEST_WEIGHT_4: "Manifest Weight 4",
  MANIFEST_WEIGHT_5: "Manifest Weight 5",
  EXPENSETYPES: "Expense Types",
  UNDER_REPAIR: "UNDER REPAIR",
  FILE_UPLOAD: "File Upload",
  VERIFIED_STATUS: "Verified Status",
  NOTVERIFY: "Not Verified",
  FRIGHT: "Freight",
  SOLD: "SOLD",
  FOR_SALE: "FOR SALE",
  INDENT_GROUP: "Indent Group",
  PAYMENT_TYPE: "Payment Mode",
  PAPERS_PENDING: "PAPERS PENDING",
  IS_PAYMENT: "Is Payment",
  LR_NUMBER_ORDER_NUMBER: "LR Number / Order Number",
  FROM: "From",
  TO: "To",
  POD: "POD",
  TRANSPORTER_NAME: "Transporter",
  REQUEST: "Request",
  ENTERED_DATE: "Entered Date",
  PAYMENT_AMOUNT: "Payment Amount",
  LOGGED_0N: "Logged On",
  USER_TOKEN: "User Token",
  CHARGE_TYPE: "Charge Type",
  CHARGE_CATEGORY: "Charge Category",
  TITLE: "Title",
  BILL_AMOUNT: "Bill Amount",
  BODY: "Body",
  PAYMENT_DATE: "Payment Date",
  DATA: "Data",
  BILL_NO: "Bill Number",
  VEHICLE_MAKE: "Vehicle Make",
  MAXIMUM_PASSING_TON: "Maximum Passing Ton",
  MINIMUM_PASSING_TON: "Minimum Passing Ton",
  VEHICLE_MODEL: "Vehicle Model",
  BILL_DATE: "Bill Date",
  EMISSION_NORMS: "Emission Norms",
  BILL_STATUS: "Close Trip",
  CLOSE_DATE: "Trip Close Date",
  PLACEMENT: "Placement",
  REFERENCE: "Reference",
  AXLE_NAME: "Axle Name",
  GROUP: "Group",
  TRIP_CAT: "Trip Category",
  IS_HYPOTHICATED: "Is Hypothicated",
  BROKER: "Broker",
  CLOSING_KM: "Closing KM",
  OPENING_KM: "Opening KM",
  RUNNING_KM: "Running KM",
  TOLL: "Toll",
  DELIVERED_QTY: "Delivered Qty",
  ORDERED_QTY: "Ordered Qty",
  NET_WT: "Net Weight",
  TARE_WT: "Tare Weight",
  GROSS_WT: "Gross Weight",
  PRODUCT: "Product",
  UNLOADING_PT: "Unloading Point",
  LOADING_PT: "Loading Point",
  LOADING_DATE: "Vehicle Available On ",
  BILLING_LOCATION: "Billing Location/Trip Reference",
  FREIGHT_MODE: "Freight Mode",
  INDENT_MODE: "Indent Mode",
  INDENT_DATE: "Vehicle Needed On",
  INDENT_CONTACT: "Indent Contact",
  INDENT_NO: "Indent No",
  TRIP: "Trip",
  TRIPS: "Trips",
  ATTACHED: "Is Attached ? ",
  FUEL_TYPE: "Fuel Type ",
  HYPOTHICATE: " Hypothicated ? ",
  PER_KM: " Per KM Expense  ",
  MILEAGE: "Mileage ",
  TRIP_LIST: "Trip List",
  AVG_SPEED: "Average Speed ",
  DAILY_TRAVEL: "Daily Travel (KM)",
  CRATE_CAPACITY: "Crates/Box Capacity",
  MIN_CRATE_CAPACITY: "Minimum Crate Capacity",
  PUC_UPTO: "PUC Upto",
  SPEED_LIMIT_UPTO: "Speed Limiter Upto",
  FITNESS_UPTO: "Fitness Upto",
  FITNESS_FROM: "Fitness From",
  INSURENCE_UPTO: "Insurance Upto",
  INSURENCE_FROM: "Insurance From",
  PERMIT_UPTO: "Permit Upto",
  PERMIT_FROM: "Permit From",
  ROADTAX_UPTO: "RoadTax Upto",
  ROADTAX_FROM: "RoadTax From",
  REGISTRATION_VALIDITY: "Registration Validity",
  INSURENCE_VALIDITY: "Insurence Validity",
  PURCHASE_DAATE: "Purchase Date",
  LOCATION: "Location",
  EMMISION_NORM: "Emission Norms",
  MANUFACTURING_YEAR: "Manufacturing Year",
  RC_STATUS: "RC Status ",
  CAME_AT: "Came At",
  LEFT_AT: "Left At",
  FASTTAG_PROVIDER: "Fastag Provider",
  FUEL_PROVIDER: "Fuel Provider",
  GPS_IMEI: "GPS IMEI",
  FAST_TAG_NO: "Fastag  Number",
  FUEL_CARD_NO: "Fuel Card number",
  PERMIT_NO: "Permit Number",
  CHASSIS_NO: "Chassis Number",
  ENGINE_NO: "Engine number",
  RESPONSE: "Response",
  MODEL: "Model",
  MAKE: "Make",
  IMEI: "IMEI",
  DRIVER_NO: "Driver Number",
  POSITION: "Position",
  PASSING_TON: "Passing Ton",
  BODY_TYPE: "Body Type",
  AXLE_TYPE: "Axle Type",
  DRIVER_NAME: "Driver Name",
  DRIVER_2_NAME: "Second Driver",
  DRIVER_BALANCE: "Driver Balance",
  OWNER_NAME: "Owner name",
  VEHICLE_TYPE: "Vehicle Type",
  VEHICLE: "Vehicle",
  VEHICLE_NO: "Vehicle Number",
  DRIVER: "Driver",
  FC: "FC",
  EMMISSION_VALIDITY: "Emission Validity",
  INSURENCE: "Insurance",
  PERMIT: "Permit",
  ROAD_TAX_END_DATE: "Road Tax End Date",
  FAST_TAG: "Fastag",
  VEHICAL_LIST: "Vehicles List",
  TRIPEXPENSE: "Trip Expense",
  AMMOUNT: "Amount",
  NAME_PLACEHOLDER: "Enter the name",
  TEMP_RANGE: "Temperature Range",
  TRUCKTYPE: "Truck Category",
  MOBILE_NO: "Mobile Number",
  TRACK_LOCATION: "Track Location",
  USER_ROLE: "User Role",
  VERIFY: "Verified",
  EXPENSE_NAME: "Expense Name",
  EXPENSETYPE: "Expense Type",
  SL_NO: "Sl No.",
  OPTIONS: "Options",
  CUSTOMER: "Customers/Supplier/Brokers",
  CUSTOMER_NAME: "Customer Name",
  PAN_NO: "PAN Number",
  GSTIN: "GSTIN",
  LOW: "Low",
  HIGH: "High",

  ADD_NEW: "Add New",
  ADD_NEW_ROW: "Add New Row",
  RELOAD: "Reload",

  //
  MASTERS_BUTTON_TRUCKTYPE: "Truck Type",
  MASTERS_BUTTON_EXPENSETYPE: "Expense Type",
  MASTERS_BUTTON_TRIPEXPENSE: "Trip Expense ",
  MASTERS_BUTTON_VEHICLES: "Vehicles",
  MASTERS_BUTTON_USERS: "Users",
  MASTERS_BUTTON_DRIVERS: "Drivers",
  MASTERS_BUTTON_CUSTOMER: "Customers",
  MASTERS_BUTTON_LOADING: "Loading",
  MASTERS_BUTTON_UNLOADING: "Unloading",
  MASTERS_BUTTON_TEMPRANGE: "Temp Range",
  MASTERS_BUTTON_ASSET: "Asset",
  MASTERS_BUTTON_ROUTE: "Route",
  MASTERS_BUTTON_LOADING_BAY_MASTER: "Loading Bay",
  // Transactions

  TRANSACTION_BUTTON_ASSIGN_VEHICLE: "Placement",
  TRANSACTION_BUTTON_ODO: "Odometer",
  TRANSACTION_BUTTON_EXPENSE: "Trip Exp",
  TRANSACTION_BUTTON_FUEL: "Fuel",
  TRANSACTION_BUTTON_POD: "POD",
  TRANSACTION_BUTTON_MAINTENANCE: "Repair",
  TRANSACTION_BUTTON_HISTORY: "History",
  TRANSACTION_BUTTON_BILL_STATUS: "Close Trip",
  TRANSACTION_BUTTON_SHOW_ROUTE: "Show Route",
  TRANSACTION_BUTTON_VEHICLE_TRACK: "Track/Map",
  TRANSACTION_BUTTON_E_POD: "E POD",
  TRANSACTION_BUTTON_DRIVER_FEEDBACK: "Feedback",
  TRANSACTION_BUTTON_EXPENSE_RECEIPT: "Trip Receipt",
  TRANSACTION_BUTTON_TRIP_PAYMENT: "Trip Payment",
  TRANSACTION_BUTTON_RETURN_REQUEST: "Return Request",
  TRANSACTION_BUTTON_RETURN_APPROVAL: "Return Approval",
  TRIP_PAYMENT: "Trip Payment",
  MINUTES_OF_MEETING: "Minutes of Meeting",
  WORK_PACKAGE: "Work Package",
  WORK_PACKAGES: "Work Packages",
  PL: "Paid Leaves",
  SL: "Sick Leaves",
  LEAVE_PLANNER_APPROVE: "Leave Approval",
  ADMIN_COMMENTS: "Admin Comments",
  ORG_CHART: "Organization Chart",
  TIME_SHEET_APPROVE: "Timesheet Approve",
  NOTES: "Notes",
  TERMS: "Terms",
  DUE_DATE: "Due Date",
  PRINT: "Print",
  INVOICES: "Invoices",
  INVOICE_PRINT: "Invoice Print",
  SELECT_TAX: "Select Tax",
  DATE_OF_INVOICE: "Invoice Date",
  PRINT_PAYSLIP: "Print Payslip",
  COMMENTS: "Comments",
  PRESENT_DAYS: "Present Days",
  ABSENT_DAYS: "Absent Days",
  TOTAL_WORKING_DAYS: "Total Working Days",
  PAY_ROLL: "Pay Roll",
  NET_PAY: "Net Pay",
  TDS: "TDS",
  PROFESSIONAL_TAX: "Professional Tax",
  TOTAL_SALARY: "Total Salary",
  MONTH_END_DATE: "Month End Date",
  MONTH_START_DATE: "Month Start Date",
  PHOTO: "Photo",
  LEAVE_PLANNER: "Leave Planner",
  PRINT_CV: "Print CV",
  SELECTED_PROF_HISTORY: "Selected Profile History",
  RECENT_PROF_HISTORY: "Recent Profile History",
  KEY_EXPERIENCE: "Key Experience",
  COUNTRIES_WORKED_IN: "Countries Worked In",
  KEY_SKILLS: "Key Skills",
  COURSE: "Course",
  QUALIFICATION: "Qualification",
  PROFESSION: "Profession",
  ADD_CV: "Add/Edit CV",
  PROJECT_COUNTY: "Project County",
  CLIENT_COUNTY: "Client County",
  CONTACT_COUNTY: "Contact County",
  PROJECT_VALUE: "Project Value",
  BUDGET_FOR_EXECUTION: "Budget For Execution",
  PROJECT_AWARD_DATE: "Project Award Date",
  CONTACT_EMAIL_ID: "Contact Email ID",
  CONTACT_EIR_CODE: "Contact EIR Code",
  CONTACT_COUNTRY: "Contact Country",
  CONTACT_ADDRESS_1: "Contact Address 1",
  CONTACT_ADDRESS_2: "Contact Address 2",
  CONTACT_ADDRESS_3: "Contact Address 3",
  CONTACT_NAME: "Contact Name",
  CLIENT_EIR_CODE: "Client EIR Code",
  CLIENT_COUNTRY: "Client Country",
  CLIENT_ADDRESS_1: "Client Address 1",
  CLIENT_ADDRESS_2: "Client Address 2",
  CLIENT_ADDRESS_3: "Client Address 3",
  PROJECT_EIR_CODE: "Project EIR Code",
  PROJECT_COUNTRY: "Project Country",
  PROJECT_ADDRESS_1: "Project Address 1",
  PROJECT_ADDRESS_2: "Project Address 2",
  PROJECT_ADDRESS_3: "Project Address 3",
  PROJECT_CLOSE_DATE: "Project Close Date",
  PROJECT_START: "Project Start",
  PROJECT_FINISH: "Project Finish",
  CLIENT_NAME: "Client Name",
  BLOOD_GROUP: "Blood Group",
  PERMANENT_ADDRESS: "Permanent Address",
  PRESENT_ADDRESS: "Present Address",
  PERSONAL_EMAIL: "Personal Email",
  OFFICE_EMAIL: "Office Email",
  E_CONTACT_NUMBER: "Emergency Contact No.",
  RESOURCE_PLANNING: "Resource Planning",
  TIME_SHEET: "Time Sheet Booking",
  TIME_SHEET_APPROVAL: "Approve Time Sheet",
  PAY_SLIP: "Pay Slip",
  INVOICE: "Invoice",
  DATE: "Date",
  FROM_DATE: "From",
  TO_DATE: "To",
  REPORT_FROM_DATE: "From Date",
  REPORT_TO_DATE: "To Date",
  LOCATION_DATE: "Location Needed On",
  EMPLOYEE: "Employee",
  NORMAL_HRS: "Normal Hours",
  DESIGNATION_MASTER: "Designation Master",
  DESIGNATION: "Designation",
  RESPONSIBILITY_MASTER: "Responsibility Master",
  RESPONSIBILITY: "Responsibility",
  LEVEL: "Level",
  PROJECT_TYPE_MASTER: "Project Type Master",
  PROJECT_TYPE: "Project Type",
  TASK_MASTER: "Task Master",
  TASK: "Task",
  HOLIDAY_MASTER: "Holiday Master",
  HOLIDAY: "Holiday",
  HOLIDAY_DATE: "Holiday Date",
  HOLIDAY_NAME: "Holiday Name",
  EMPLOYEE_MASTER: "Employees List",
  EMPLOYEE_ID: "Employee ID",
  EMPLOYEE_NAME: "Employee Name",

  TRUCK_CATEGORY: "Truck Category",
  STATUS: "Status",
  SCHEDULE_UPDATE_FREQUENCY: "Schedule Update Frequency",
  RISKS_REGISTER: "Risks Register",
  NEW_PASSWORD: "New Password",
  CURRENT_PASSWORD: "Current Password",
  SETTINGS: "Settings",
  CONSTRAINTS: "Constraints",
  SPENT_HRS: "Spent Hours",
  TASK_OWNER: "Task Owner",
  EMP_ID: "Employee ID",
  SELECT_DATE: "Status/Data Date",
  SELECT_DATE_TIME: "Select Date",
  RESOURCE_PLANNING_REPORT: "Resource Planning Report",
  PROJECTS_REPORT: "Projects Report",
  TIME_SHEET_REPORT: "Time Sheet Report",
  INVOICE_REPORT: "Project Invoice Report",
  INVOICE_REGISTER: "Invoice Register",
  COST_REPORT: "Cost Report",
  APPROVAL_LOG_REPORT: "Approval Log Report",
  VEHICLES_REGISTER_REPORT: "Vehicles Register",
  DRIVERS_REGISTER_REPORT: "Drivers Register",
  VEHICLES_LIST_REPORT: "VehiclesList",
  DRIVERS_LIST_REPORT: "Drivers List",
  DOCUMENT_RENEWAL_REPORT: "Document Renewal",
  TRIPS_REGISTER_REPORT: "Trips Register",
  TRIP_STATUS_REPORT: "Trip Status Register",
  TRIP_REGISTER_REPORT: "Trip Register",
  VEHICLES_LIST_REPORTS: "Vehicles List Report",
  VEHICLE_REGISTER_REPORT: "Vehicles Register",
  VEHICLE_LOCATION_REPORT: "Vehicles Location",
  DRIVER_REGISTER_REPORT: "Driver Register",
  BROKER_REGISTER_REPORT: "Broker Register",
  TRIP_LEDGER_REPORT: "Trip Ledger",
  VEHICLE_LEDGER_REPORT: "Vehicle Ledger",
  DRIVER_LEDGER_REPORT: "Driver Ledger",
  BROKER_LEDGER_REPORT: "Broker Ledger",
  TRIP_NOTIFICATION_REPORT: "Trip Notifications",
  FUEL_REGISTER_REPORT: "Fuel Regiser",
  EXPENSES_REGISTER_REPORT: "Expenses Register",
  MILEAGE_REPORT: "Mileage Report",
  ALL_LOGS_REPORT: "All Logs Report",
  USER_LOG_REPORT: "User Log Report",
  VIEW: "View",
  APPROVE: "Approve",
  REJECT: "Reject",
  APPROVE_FILE: "Approve File",
  COST: "Cost",
  CURRENCY: "Currency",
  UNIT: "Unit",
  QTY: "Qty.",
  PHOTOS: "Photos",
  EXPORT_TO_PDF: "Export To PDF",
  SIX_WEEKS_VIEW: "6 Weeks View",
  ONE_MONTH_VIEW: "1 Month View",
  SHOW_ALL: "Show All",
  TASK_NAME: "Discipline",
  REPORTS: "Reports",
  DASHBOARD: "Dashboard",
  MASTERS: "Masters",
  TRANSACTIONS: "Transactions",
  PROJECT_MANAGER: "Project Manager",
  PROJECT_CHART: "Project Chart",
  PROJECT_CRITICAL_PATH: "Project Critical Path",
  WEEK_LOOK_AHEAD_SCHEDULE: "Week Look Ahead Schedule",
  PROJECT_REMAINING_DURATION: "Project Remaining Duration",
  EXPAND_ALL: "Expand All",
  PERCENTAGE: "Percentage",
  CRITICAL_PATH: "Critical Path",
  NEAR_TO_CRITICAL_PATH: "Near To Critical Path",
  PROJECT_CASH_FLOW: "Project Cash Flow",
  PROGRESS_CURVE: "Progress S Curve",
  MAN_HOURS_DISTRIBUTION: "Man Hours Distribution",
  RESOURCE_TABLE: "Resource Table",
  FINISH_DATE: "Finish Date",
  START_DATE: "Start Date",
  EDIT_CHART: "Edit Chart",
  PROJECT_OVERVIEW: "Project Overview",
  PROJECT_PROGRESS_STATUS: "Project Progress Status vs Earned",
  MAN_HOURS_PLAN: "Man Hours Distribution",
  RESOURCE_HISTOGRAM: "Resource Histogram",
  VIEW_PROJECT_CHARTER: "View Project Charter",
  PROJECT_CHARTER: "Project Charter",
  CONFIRM: "Confirm",
  LOAD: "Load",
  CONTACT_NUMBER: "Contact Number",
  INCHARGE: "Incharge",
  ADDRESS_1: "Address 1",
  ADDRESS_2: "Address 2",
  ZIPCODE: "Zipcode",
  UPLOAD: "Upload",
  SELECT_FILE: "Choose File",
  FILE_UPLOAD_TYPE: "File Upload Type",
  SUPERVISOR: "Supervisor",
  PROJECT_NAME: "Project Name",
  PROJECT_CODE: "Project Code",
  SELECT_PROJECT: "Select Project",
  DELETE: "Delete",
  EDIT: "Edit",
  SAVE: "Save",
  CANCEL: "Cancel",
  HOME: "Home",
  PROJECTS: "Projects List",
  GANTT_CHART: "Gantt Chart",
  USERS: "Users List",
  ORGANIZATION: "Organization",
  ORGANIZATIONS: "Organizations",
  LOGOUT: "Logout",
  FIRST_NAME: "First Name",
  LAST_NAME: "Last Name",
  USER_NAME: "User Name",
  PASSWORD: "Password",
  LOGIN: "Login",
  REMEMBER_ME: "Remember Me",
  SIGN_IN_NOTE:
    "Note: By signing in, I agree that this website can set cookies on my browser.",
  MENU: "Menu",
  SEARCH: "Search",
  EMAIL_ID: "Email ID",
  PHONE: "Phone Number",
  USER_TYPE: "User Type",
  ACTIVE: "Active",
  INACTIVE: "Cancel/Hide",
  CHARGEABLE: "Chargeable",
  DIRECTOR: "Director",
  PROJECT_STATUS: "Project Status",
  //
  REGION: "Region",
  NOTIFICATION_SUBSCRIPTION: "Notification Subscription",
  NAME: "Name",
  GEO_FENCE_ID: "Geo Fence ID",
  DISTANCE_IN_KM: "Distance in KM",
  TAT_IN_HOURS: "TAT in Hours",
  ALERT_IN_KM: "Alert in (KM)",
  LOAD_TIME: "Load / Unload time (Hours) ",
  ADDRESS: "Address",
  CONTACT_PERSON: "Contact Person ",
  CONTACT_MOBILE: "Enter your Mobile Number below",
  LOADING_STATUS: "Loading Status",
  ACTIVE_STATUS: "Active Status",
  LOADING_POINTS_ONLY: "Loading Points Only",
  UNLOADING_STATUS: "Unloading Status",
  UNLOADING_POINTS_ONLY: "Unloading Points Only",
  LOADING_BAY_MASTER: "Loading Bay",
  //
  ROUTE: "Route",
  START_PLACE: "Start Place",
  END_PLACE: "End Place",
  ROUTE_DETAILS: "Route details",
  //
  PURCHASED_FROM: "Purchased from",
  SERIAL_NUMBER: "Serial No / Comment",
  QUANTITY: "Quantity",
  ASSET_TYPE: "Asset Type",
  SELECT_VEHICLES: "Select Vehicle",
  ASSET_NAME: "Asset Name",
  PURCHASE_DATE: "Purchase Date",
  //
  VEHICLE_NAME: "Vehicle Name",
  //
  DRIVERS_NAME: "Driver Name",
  DRIVER_TYPE: "Driver  Type",
  DL_NUMBER: "DL Number ",
  DL_ISSUING_AUTHORITY: "DL Issuing Authority",
  SWD_OF: "SWD OF",
  VEHICLE_TYPES: "Vehicle Types",
  MOBILE_ALTERNATIVE: "Mobile(alternative)",
  EMPLOYEE_CODE: "Employee Code",
  MOBILE_CUG: "Mobile CUG",
  BENEFICIARY_NAME: "Beneficiary Name",
  ACCOUNT_NUMBER: "Account Number",
  BANK_NAME: "Bank Name",
  BRANCH: "Branch",
  IFSC_CODE: "IFSC Code",
  AADHAR_NUMBER: "Adhaar Number ",
  PAN_NUMBER: "PAN Number",
  UAN_NUMBER: "UAN",
  RELATIVE: "Relative",
  RELATION: "Relation",
  EMERGENCY_NUMBER: "Emergency Number ",
  TEMPERORY_ADDRESS: "Temporary Address",
  DL_ISSUED_ON: "DL Issued On ",
  DL_VALID_UPTO: "DL Valid Upto",
  DATE_OF_BIRTH: "Date of Birth",
  JOINING_DATE: " Joining Date",
  TR_DUE_DATE: "TR Due Date",
  NT_DUE_DATE: "NT Due Date",
  TRANSACTION_MODE: "Transaction Mode",

  //
  FUEL: "Fuel",
  // TRIP: "Trip",
  TRANSACTION_DATE: "Transaction Date",
  CATEGORY: "Category",
  REMARKS: "Remarks",
  FUEL_QUANTITY: "Fuel Qty",
  REFERENCE_NUMBER: "Reference Number",
  PAYMENT_MODE: "Payment Mode",
  //
  WORK_DATE: "Work Date",
  WORK_TYPE: "Work Type",
  WORK_LOCATION: "Work Location",
  DESCRIPTION: "Description",
  DEBIT: "Debit",
  CREDIT: "Credit",
  //
  PAYMENT_RECEIPT: "Select if Payment/Receipt",
  //
  YES: "Yes",
  NO: "No",
  //

  RETURN_REQUEST: "Return Request",
  RETURN_APPROVAL: "Return Approval",
  PICKUP_POINT: "Pickup Point Area",
  APPROVED_USERS: "Approved Users",
  ENTER_RETURN_REQUEST: "Enter Your Request",
  ENTERED_RETURN_REQUEST: "Entered Request",
  APPROVED_BY: "Approved by",
  APPROVED_ON: "Approved On",
  APPROVED_COMMENTS: "Approved Comments",
  ENTERED_BY: "Entered By",
  COMMENTS_BY_APPROVER: "Comments By Approver",
  //
  VEHICLE_DRIVER_INFO: "Vehicle and Driver Info ",
  VEHCILE_SPECIFICATION: "Vehicle Specification",

  PREV_NP_DATE: "Previous NP Date",
  NEXT_NP_DUE_DATE: "Next NP Due Date",
  EMI_AMOUNT: "EMI Amount",
  EMI_DAYS: "EMI Days",
  PREV_ROADTAX_DATE: "Previous Road Tax Date",
  NP_5YR_VALIDITY: "NP 5 Year Validity  ",
  NP_10YR_VALIDITY: "NP 10 Year Validity  ",
  REEFER_FUEL_PER_HR: "Reefer Fuel Per Hour",
  LOAN_ACCOUNT_NUMBER: "Loan Account Number",
  LOAN_BANK_NAME: "Loan Bank Name ",
  INSURANCE_NUMBER: "Insurance Number",
  INSURANCE_COMP_NAME: "Insurance Company Name",
  LOAN_DETAILS: "Loan Details",
  FUEL_DETAILS: "Fuel Details",
  VEHICLE_DOCUMENTATION_DETAILS: "Vehicle Documentation Details",
  VEHICLE_PAYEMENT_AND_NAV_DETAILS: "Vehicle Payment and Navigation Details",
  VEHICLE_IDENTIFICATION: "Vehicle Identification ",

  //
  DRIVER_DETAILS: "Driver Details",
  DRIVER_VEHICLE_DETAILS: "Driver Vehicle Details",
  EMPLOYEE_DETAILS: "Employee Details",
  OTHER_DETAILS: "Other Details",
  BANK_DETAILS: "Bank Details",
  FREIGHT_AND_INDENT_DETAILS: "Freight and Indent Details",
  DIESEL: "DIESEL",
  ADVANCE: "Advance",
  PETROL: "PETROL",
  CNG: "CNG",
  ELECTRIC: "ELECTRIC",
  ELECTRICAL: "ELECTRICAL",
  HELPER: "HELPER",
  CLEANER: "CLEANER",
  NON_TRIP: "Non Trip",
  OTHER: "Other",
  OTHERS: "OTHERS",
  TYRE: "TYRE",
  ENGINE_OIL: "ENGINE OIL",
  FILTERS: "FILTERS",
  BELT: "BELT",
  BEARING: "BEARING",
  HOSES: "HOSES",
  FASTENERS: "FASTENERS",
  TOOLS: "TOOLS",
  DDL_NUMBER: "DDL Number",
  CUG: "CUG",
  TO_PAY: "TO PAY",
  PAID: "PAID",
  TBB: "TBB",
  OWN_TRIP: "OWN TRIP",
  REVENUE_TRIP: "REVENUE TRIP",
  EMPTY_TRIP: "EMPTY TRIP",
  RAW_MATERIAL_TRIP: "RAW MATERIAL TRIP",
  MOBILE: "MOBILE",
  SAP: "SAP",
  MARKET: "MARKET",
  COMPANY: "COMPANY",
  IND_PHONE: "PHONE",
  EMAIL: "EMAIL",
  WHATSAPP: "WHATSAPP",
  MESSAGE: "MESSAGE",
  PAYMENT: "PAYMENT",
  RECEIPT: "RECEIPT",
  CASH: "CASH",
  BANK: "BANK",
  UPI: "UPI",
  CARD: "CARD",
  NONE: "NONE",
  REEFER: "REEFER",
  PERIODIC: "PERIODIC",
  BREAKDOWN: "BREAKDOWN",
  BREAKDOWN1: "Breakdown",
  HIDE: "Hide",
  CANCELED: "Cancel",
  //
  LOAD_WEIGHTS: "Load Weights",
  WEIGHT: "Weight",
  TRANSIT_DAYS: "Transit Days",
  INDENT_STATUS: "Indent Status",
  TRIP_STATUS: "Trip Status",
  DELIVERY_DETAILS: "Delivery Details",
  INITIAL_TRIP_DATA: "Initial Trip Data",
  ROUND_TRIP:
    "Round Trip (If selected, system will consider that vehicle will return to First loading first for closing of Trip)",
  RAJKOT: "RAJKOT",
  MODASA: "MODASA",
  NAGPUR: "NAGPUR",
  TRANSACTION_MODE_OF_GOPAL: "Transaction Location",
  SHOW_ALL_POINTS: "Show All Points",
  SHOW_LOADING_POINTS: "Show Loading Points",
  //
  REDEEMED_KEY: "Redeemed Key",
  PROFILE_PIC: "Profile Picture",
  VERIFIED_ON: "Verified On",
  IS_VAHAN_VERIFIED: "Is Vahan Verified",
  CURRENT_LOCATION: "Current Location",
  LATITUDE: "Latitude",
  LONGITUDE: "Longitude",

  LOADING_BAY: "Loading Bay",
  //vehicle forms
  IS_ATTACHED: "Is Attached",
  //
  ASSETS_REGISTER: "Assets Register",
  SERIAL: "Serial",
  EXPENSE_ANALYSIS: "Expense Analysis",

  TRIP_DATE: "Trip Date",
  PLANNED_EXPENSE: "Planned Expense",
  ACTUAL_EXPENSE: "Actual Expense",
  DEVIATION: "Deviation",
  TOTAL_BOXES: "Total Boxes",
  WEIGHT_EXPENSE: "Weight Expense",
  BOX_EXPENSE: "Box Expense",

  //
  PROFIT_LOSS_ANALYSIS: "Profit Loss Analysis ",
  INCOME: "Income",
  EXPENSE: "Expense",
  PROFIT: "Profit",
  PER_WEIGHT_PROFIT: "Per Weight Profit",
  PER_BOX_PROFIT: "Per Box Profit",
  NON_MOVEMENT_VEHICLE_LIST: "Non Movement Vehicle List",
  IDLE_FROM: "Idle From",
  TOTAL_DAYS: "Total Days",
  LOADING_BAY_REPORT: "Loading Bay Report",
  IN_TIME: "In Time ",
  OUT_TIME: "Out Time",
  TURN_AROUND_TIME: "Turn Around Time ",
  UNLOADING_LOCATION: "Unloading Location",
  TRUCK_TURNING_TIME: "Truck Turning Time",
  DWELL_TIME: "Dwell Time",
  TRANSPORTATION_COST: "Transportation Cost",
  EXPENSE_TOTAL: "Expense Total",
  TOTAL_KM: "Total Km",
  AVG_COST_PER_KM: "Avg Cost PerKM",
  RETURNS_REPORT: "Returns Report",
  RETURN_PICKUP_STATUS: "Return Pickup Status",
  PICKUP_POINT_AREA: "Pickup Point Area",
  ENTERED_BY_USER: "Enterd By User",
  APPROVED_BY_USER: "Approved By User",
  ODOMETER_MISMATCH: "Odometer Mismatch",
  ODOMETER_OPENING: "Odometer Opening",
  ODOMETER_OPENDATE: "Odometer Open Date",
  OPENING_ENTRY_BY: "Opening Entry By",
  ODOMETER_CLOSING: "Odometer Closing",
  ODOMETER_CLOSE_DATE: "Odometer Close Date",
  CLOSING_ENTRY_BY: "Closing Entry By",
  MISMATCH: "Mismatch",
  IDLE_RUN_REPORT: "Idle  Report",

  TRIP_NUMBER: "Trip Number",
  //
  REACH_BY: "Reach By",
  PARKING_LOT_REPORT: "Parking Lot Report",
  ASSET: "Asset",
  DRIVERS: "Drivers",
  LOADING_POINTS: "Loading Points",
  UNLOADING_POINTS: "Unloading Points",
  DELIVERY_COMMENTS_REPORT: "Delivery Comments Report",
  REPAIRS: "Repairs",
  SELECT_CUSTOMER_SUPPLIER_BROKER_LEDGER:
    "Select Customer/Supplier/Broker Ledger",
  IDLE_TO: "Idle To",
  SELECT_DAYS: "Select Days",
  DAY_WISE: "Day Wise",
  WEEK_WISE: "Week Wise",
  MONTH_WISE: "Month wise",
  SELECT_DWELL_TIME: "Select Dwell Time",
  TRIP_START: "Trip Start",
  TRIP_END: "Trip End",
  PLANNED_KM: "Planned KM",
  ROUTE_TAT_IN_HOURS: " Route TAT in Hours",
  ACTUAL_TAT_IN_HOURS: " Actual TAT in Hours",
  //
  FUEL_REPORT: "Fuel Report",
  FASTAG_REPORT: "Fastag Report",
  //
  LOG_TIME: "Log Time",
  CARD_NUMBER: "Card Number",
  MERCHANT_NAME: "Merchant Name",
  TRANSACTION_ID: "Transaction Id",
  TRANSACTION_DATE_TIME: "Transaction Date Time",
  TRANSACTION_TYPE: "Transaction Type",
  SETTLEMENT_DATE: "Settlement Date",
  SETTLEMENT_SATAUS: "Settlement Status",
  RSP: "RSP",
  STATE: "State",
  ODOMETER: "Odometer",
  LANE_CODE: "Lane Code",
  PLAZA_CODE: "Plaza Code",
  PLAZA_NAME: "Plaza Name",
  SERIAL_NO: "Serial No.",
  ODOMETER_READING: "Odometer Reading",
  POSITION_OF_TYRE: "Position of Tyre",
  PRINT_HINDI: "Print Hindi",
  PRINT_ENGLISH: "Print English",
  PRINT_GUJARATI: "Print Gujarati",
};

export const CONFIRMS = {
  SURE_TO_LOGOUT: "Are you sure want to logout..?",
  DELETE_USER: "Are you sure want to delete this user..?",
  SURE_TO_APPROVE: "Are you sure want to approve this..?",
  SURE_TO_SAVE: "Are you sure want to save this..?",
};

export const SUCCESS = {
  RECORD_SUCCESS: "Record Saved Successfully..!",

  PASSWORD_CHANGED: "Password Changed Successfully..!",
  LOGIN_SUCCESS: "Login Successful, Redirecting to home page..!",
  LOGOUT_SUCCESS: "Logout successful, Redirecting to login page..!",
  SIGNUP_SUCCESS: "Signup successful..!",
  PROPERTY_SAVED: "Property Saved Successfully..!",
  FILE_UPLOADED: "File Uploaded Successfully..!",
  PROJECT_SUCCESS: "Project Saved Successfully..!",
  ORGANIZATION_SUCCESS: "Organization Saved Successfully..!",
  USER_SUCCESS: "User Saved Successfully..!",
  CHART_INFO_UPDATED: "Chart Info Updated Successfully..!",
  FILE_APPROVED: "File Approved Successfully..!",
};

export const WARNINGS = {
  IS_A_REQUIRED_FIELD: "is a required field",
  FILE_SIZE_EXCEEDED: "File size exceeded..!",
  WORK_PACKAGE_EMPTY: "Work Package is Mandatory..!",
  TRUCK_TYPE_EMPTY: "truck type is Mandatory..!",
  EXPENSE_NAME_EMPTY: "expense name is Mandatory..!",
  EXPENSE_TYPE_EMPTY: "expense type is Mandatory..!",
  MIN_CHAR_REQUIRED_FIELD: "requires minimum 4 letters..!",

  PROJECT_TYPE_EMPTY: "Project Type Name is Mandatory..!",
  DESIGNATION_NAME_EMPTY: "Designation Name is Mandatory..!",
  RESPONSIBILITY_NAME_EMPTY: "Responsibility Name is Mandatory..!",
  EMP_IS_EMPTY: "Employee is mandatory..!",
  DATA_IS_EMPTY: "Selection is mandatory..!",

  BOTH_PASSWORDS_SAME: "Current & New Password should not be same..!",
  NPWD_LENGTH_SMALL:
    "New Password Length should be greater than 6 characters..!",
  CPWD_EMPTY: "Current Password is empty..!",
  NPWD_EMPTY: "New Password is empty..!",
  DATE_EMPTY: "Please select date..!",
  TASK_EMPTY: "Please select Task..!",
  FILE_NOT_FOUND: "File Not Found..!",
  INVALID_EMAIL: "Invalid Email ID..!",
  USER_TYPE_EMPTY: "Please Select User Type..!",
  USER_NAME_IS_EMPTY: "Please Enter User Name..!",
  FIRST_NAME_IS_EMPTY: "Please Enter First Name..!",
  CONTACT_NO_IS_EMPTY: "Please Enter Incharge Contact Number..!",
  INCHARGE_IS_EMPTY: "Please Enter Incharge Name..!",
  ORG_NAME_IS_EMPTY: "Please Enter Organization Name..!",
  ZIPCODE_IS_EMPTY: "Please Enter Zipcode..!",
  ADDRESS_IS_EMPTY: "Please Enter Address..!",
  SUPERVISOR_EMPTY: "Please select Supervisor..!",
  ORG_EMPTY: "Please select Organization..!",
  PROJECT_NAME_EMPTY: "Please enter the Project Name..!",
  PROJECT_EMPTY: "Please select project..!",
  TRIP_EMPTY: "Please select trips..!",
  FILE_EMPTY: "Please select file..!",
  USERNAME_IS_EMPTY: "Username is mandatory..!",
  PASSWORD_IS_EMPTY: "Password is mandatory..!",
  PROPERTY_TYPE_EMPTY: "Please select property type..!",
  STATE_EMPTY: "Please select state..!",
  CITY_EMPTY: "Please select city..!",
  AREA_EMPTY: "Please select Area..!",
  ADDRESS_EMPTY: "Please enter address..!",
  PROPERTY_NAME_EMPTY: "Please enter address..!",
  PROPERTY_DESC_EMPTY: "Please enter property description..!",
  PROPERTY_OWNER_EMPTY: "Please enter property owner name..!",
  MANDATORY: "Please fill all the mandatory fields..!",
  PLEASE_CHECK_FORM_ERRORS: "Please check form errors..!",
};

export const ERRORS = {
  RECORD_FAILED: "Record Not Saved..!",

  LOGIN_FAILED: "Login Failed: Invalid Username or Password..!",
  LOGOUT_FAILED: "Logout failed..!",
  SCORE_FAILED: "Score Calculations Failed..!",
  FILE_NOT_UPLOADED: "File Not Uploaded Successfully..!",
  PROJECT_FAILED: "Project Not Saved..!",
  ORGANIZATION_FAILED: "Organization Not Saved..!",
  USER_FAILED: "User Not Saved..!",
  CHART_INFO_NOT_UPDATED: "Chart Info Not Updated Successfully..!",
  FILE_APPROVE_FAILED: "File Not Approved Successfully..!",
};

export const INFO = {
  EXPORT_AS_PDF: "Export as PDF",
  EXPORT_AS_PNG: "Export as PNG",
};
